import { requestApi } from '@app/api';
import { withBulkRequest } from '@app/api/paths';

import FormResponse from './FormResponse';

export function getBulkRequestsForm(
  workspaceId: string,
  bulkRequestId: string
): Promise<FormResponse> {
  return requestApi<FormResponse>({
    url: withBulkRequest(`/workspaces/${workspaceId}/bulk-requests/${bulkRequestId}/form`),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data);
}
